// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

export const FLEET_DASHBOARD_BASE_ROUTE = '/fleet-dashboard'

export const BaseFleetDashboardAreaRoutes = {
  route: FLEET_DASHBOARD_BASE_ROUTE,
}

export const FleetDashboardAreaRoutes = transformRoutes(
  BaseFleetDashboardAreaRoutes,
)
